export class AssingResponsibleRequestType
    {
        responsibleId: string;
        requestTypeId: string;
        lineId: string;
    }